<template>
  <v-app>
    <AppBar />
    <NavigationDrawer />
    <v-main :class="[isDarkMode ? 'dark-main' : 'light-main', { 'assistant-shift': shiftForAssistant }]">
      <router-view></router-view>
    </v-main>
    <AiNpcAssistantHost />
    <BizhubAssistantHost />
    <GuestWelcomeModal v-if="authStore.isGuest" />
    <!-- 👈 モーダル追加 -->
  </v-app>
</template>

<script setup>
import AppBar from "@/components/AppBar.vue";
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import GuestWelcomeModal from "@/components/GuestWelcomeModal.vue";
import AiNpcAssistantHost from "@/components/AiNpcAssistantHost.vue";
import BizhubAssistantHost from "@/components/bizhub/BizhubAssistantHost.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useTheme } from "vuetify";
import { useAuthStore } from "@/stores/authStore";
import { useAiNpcAssistantStore } from "@/stores/aiNpcAssistantStore";
import { useBizhubAssistantStore } from "@/stores/bizhubAssistantStore";

const theme = useTheme();
const isDarkMode = computed(() => theme.global.name.value === "dark");
const authStore = useAuthStore();
const route = useRoute();
const assistantStore = useAiNpcAssistantStore();
const bizhubAssistant = useBizhubAssistantStore();
// AiNpc / 業務管理ページでアシスタントパネルを開いたら、コンテンツを左に寄せて被りを防ぐ。
const shiftForAssistant = computed(
  () => (assistantStore.open && !!route.meta?.requiresAiNpc) || (bizhubAssistant.open && !!route.meta?.requiresBizhub),
);
</script>

<style scoped>
.dark-main {
  background-color: #121212 !important; /* Vuetifyのダークテーマの背景色 */
  color: white !important;
}

.light-main {
  background-color: #f5f5f5 !important; /* ライトテーマの背景色 */
  color: black !important;
}

/* アシスタントパネル（440px）を開いたら本体を左に寄せる */
.assistant-shift {
  padding-right: 440px;
  transition: padding-right 0.25s ease;
}
/* 狭い画面ではシフトせずオーバーレイに任せる */
@media (max-width: 960px) {
  .assistant-shift {
    padding-right: 0;
  }
}
</style>
